import React, { Fragment } from 'react'
import { connect } from 'react-redux'

import { getAvatarUrl, getName } from 'modules/user/selectors'

import defaultAvatar from './default-avatar.png'
import arrowSrc from './arrow.svg'

import './style.css'

const MeetingTypeCard = ({ title, duration, headerColor, avatarComponent }) => {
  return (
    <div className="meeting-type-card" style={{ borderColor: `#${headerColor}` }}>
      {avatarComponent}
      <div className="meeting-type-card-content">
        <p>{title}</p>
        <p>{duration} minutes</p>
      </div>
    </div>
  )
}

const MeetingTypesPreview = ({ isCalendarSeat, avatarUrl, name }) => {
  const initials =
    name &&
    name
      .split(' ')
      .map(word => word[0])
      .slice(0, 2)
      .join('')

  const avatarComponent = (
    <Fragment>
      {avatarUrl && (
        <div
          className="meeting-type-card-avatar"
          style={{ backgroundImage: `url(${avatarUrl})` }}
          alt="profile_photo"
        />
      )}
      {!avatarUrl && initials && <div className="meeting-type-card-avatar avatar-gradient">{initials}</div>}
      {!avatarUrl && !initials && <img className="meeting-type-card-avatar" src={defaultAvatar} alt="profile_photo" />}
    </Fragment>
  )

  return (
    <div className="meeting-types-preview">
      <div className="meeting-types-preview-message">
        <p>Create your own meeting types for everything from short discovery calls to long demos</p>
        <img className="meeting-types-arrow" src={arrowSrc} alt="" />
      </div>
      <div className="meeting-types-preview-container">
        <div className="preview-left-col">
          <MeetingTypeCard
            title="Discovery Call"
            duration="15"
            headerColor="f5f8fa"
            avatarComponent={avatarComponent}
          />
          <MeetingTypeCard
            title="Deep Dive"
            duration="45"
            headerColor="f2fdf8"
            avatarComponent={avatarComponent}
          />
        </div>
        <div className="preview-right-col">
          <MeetingTypeCard
            title="Quick Demo"
            duration="30"
            headerColor="fff7e0"
            avatarComponent={avatarComponent}
          />
          <MeetingTypeCard
            title="Platinum Demo"
            duration="60"
            headerColor="d8eaff"
            avatarComponent={avatarComponent}
          />
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  avatarUrl: getAvatarUrl(state),
  name: getName(state),
})

export default connect(mapStateToProps)(MeetingTypesPreview)



// WEBPACK FOOTER //
// ./src/layouts/MeetingTypesPreview/index.js